// import { useState, useMemo } from "react";
// import { Form } from 'react-bootstrap';
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   ResponsiveContainer,
// } from "recharts";
// import dayjs from "dayjs";
// import NoDataFound from "../../NoDataFound";
// import { isMobile } from "react-device-detect";


//     // {attendanceData =[]}
// function StudentAttendance2() {
//   const [selectedMonth, setSelectedMonth] = useState("2025-10");

//   const availableMonths = Array.from(
//     new Set(attendanceData.map(d => dayjs(d.attendance_date).format("YYYY-MM")))
//   );

//   const filteredData = useMemo(() => {
//     return attendanceData
//       .filter(
//         d => dayjs(d.attendance_date).format("YYYY-MM") === selectedMonth
//       )
//       .map(d => ({
//         date: dayjs(d.attendance_date).format("D-MMM"),
//         status: d.status === "present" ? 1 : 0,
//       }));
//   }, [selectedMonth]);


//   return (

//     <>
//     <div className="p-3 border rounded-4 shadow-lg">
//         <div className="d-flex justify-content-between">
//             <h5 className="fw-bold text-dark mb-3">
//             Activity
//             </h5>
//             {availableMonths?.length !=0 &&
//             <Form.Select
//             className={`mb-3  ${isMobile ? 'w-50':'w-25'}`}
//             value={selectedMonth}
//             onChange={(e) => setSelectedMonth(e.target.value)}
//             >
//             {availableMonths?.map(m => (
//                 <option key={m} value={m}>
//                 {dayjs(m).format("MMMM")}
//                 </option>
//             ))}
//             </Form.Select>}
//         </div>

//         {!filteredData || filteredData.length === 0 ? <NoDataFound message='📊 No attendance data is available for this student.'/>:
//         <ResponsiveContainer width="100%" height={300}>
//             <BarChart data={filteredData} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
//             <CartesianGrid strokeDasharray="3 3" />
//             <XAxis dataKey="date" interval={0} tick={{ angle: -45, textAnchor: "end" }}  />
//             <YAxis
//                 ticks={[0, 1]}
//                 tickFormatter={(v) => (v === 1 ? "Present" : "")}
//             />
//             <Tooltip
//                 formatter={(v) => (v === 1 ? "Present" : "")}
//                 labelFormatter={(l) => `Date: ${l}`}
//             />
//             <Bar dataKey="status" fill="#3498db" barSize={5} radius={[10, 10, 0, 0]}/>
//             </BarChart>
//         </ResponsiveContainer>
//         }

//     </div>
//     </>
//   );
// }

// export default StudentAttendance2

import { useState, useMemo } from "react";
import { Form } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import dayjs from "dayjs";
import NoDataFound from "../../NoDataFound";
import { isMobile } from "react-device-detect";


function StudentAttendance2({attendanceData =[]}) {
  const [selectedMonth, setSelectedMonth] = useState("2025-10");

  const availableMonths = Array.from(
    new Set(attendanceData.map((d) => dayjs(d.attendance_date).format("YYYY-MM")))
  );

  const filteredData = useMemo(() => {
    return attendanceData
      .filter((d) => dayjs(d.attendance_date).format("YYYY-MM") === selectedMonth)
      .map((d) => ({
        date: dayjs(d.attendance_date).format("D-MMM"),
        status: d.status === "present" ? 1 : 0,
      }));
  }, [selectedMonth]);

  return (
    <div className="p-3 border rounded-4 shadow-lg">
      <div className="d-flex justify-content-between">
        <h5 className="fw-bold text-dark mb-3">Daily Attendance</h5>
        {availableMonths?.length !== 0 && (
          <Form.Select
            className={`mb-3 ${isMobile ? "w-50" : "w-25"}`}
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            {availableMonths?.map((m) => (
              <option key={m} value={m}>
                {dayjs(m).format("MMMM")}
              </option>
            ))}
          </Form.Select>
        )}
      </div>

      {!filteredData || filteredData.length === 0 ? (
        <NoDataFound message="📊 No attendance data is available for this student." />
      ) : (
        <div
          style={{
            overflowX: isMobile ? "auto" : "visible",
            paddingBottom: isMobile ? "10px" : "0",
          }}
        >
          <div
            style={{
              width: isMobile ? `${filteredData.length * 45}px` : "100%", // each bar ~45px wide
              minWidth: "300px",
              height: "300px",
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={filteredData}
                margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="date"
                  interval={0}
                  tick={{ angle: -45, textAnchor: "end", fontSize: 12 }}
                />
                <YAxis
                  ticks={[0, 1]}
                  tickFormatter={(v) => (v === 1 ? "Present" : "")}
                />
                <Tooltip
                  formatter={(v) => (v === 1 ? "Present" : "")}
                  labelFormatter={(l) => `Date: ${l}`}
                />
                <Bar dataKey="status" fill="#3498db" barSize={10} radius={[10, 10, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </div>
  );
}

export default StudentAttendance2;